import { render, staticRenderFns } from "./main-location.vue?vue&type=template&id=3602bfa0&scoped=true"
import script from "./main-location.vue?vue&type=script&lang=js"
export * from "./main-location.vue?vue&type=script&lang=js"
import style0 from "./main-location.vue?vue&type=style&index=0&id=3602bfa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3602bfa0",
  null
  
)

export default component.exports